import { Component, OnInit, OnDestroy } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader'; // <============
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';

@Component({
  selector: 'app-allergyrating',
  templateUrl: './allergyrating.component.html',
  styleUrls: ['./allergyrating.component.scss']
})
export class AllergyratingComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  dishId
  allreviewData
  errorMessage
  response_status
  userName
  userName_loggedin
  allergenreview = []
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  user_Name: any;
  constructor(store: Store<IAppState>,
    public httpSv: HttpService, private router: Router,
    private route: ActivatedRoute, private _bottomSheet: MatBottomSheet,
    private _location: Location) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: 'review'
        }
      ]
    };
  }
  allergyRatingDishName
  ngOnInit() {
    this.allergyRatingDishName = this.route.snapshot.queryParamMap.get('dishname');
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.dishId = sessionStorage.getItem('dishId')
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    this.getAllergyReviews()
  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }
  backTologin() {
    this.router.navigate(['/public/sign-in']);
  }
  backHomeUser() {
    this.router.navigate(['/horizontal/resto'])
  }
  backHomeGuest() {
    this.router.navigate(['/public/resto'])
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  backClicked() {
    this._location.back();
  }

  allergyRatingsArray: any[] = [];
  getAllergyReviews() {
    this.httpSv.getAllergyReviewBasedonDishId(this.restoID, this.dishId).subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.allergyRatingsArray = res['result'];
        // to map sample image in each object
        this.allergyRatingsArray.forEach((item: any) => {
          this.allergyRatingsArray = this.allergyRatingsArray.map(v => ({
            ...v, profile_img: "assets/img/sample-profile.png"
          }))
        })


      }
    }, (err: any) => {
      console.log(err);
    })
  }
}